webpackJsonp([3],{

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(111);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(92);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Pages = __webpack_require__(346);
	
	var styles = _interopRequireWildcard(_Pages);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      searchQuery: '',
	      searchOpen: false
	    };
	
	    _this.toggleSearch = _this.toggleSearch.bind(_this);
	    _this.search = _this.search.bind(_this);
	    return _this;
	  }
	
	  IndexPage.prototype.toggleSearch = function toggleSearch(event) {
	    event.preventDefault();
	
	    this.setState({ searchOpen: !this.state.searchOpen });
	  };
	
	  IndexPage.prototype.search = function search(event) {
	    this.setState({ searchQuery: event.currentTarget.value });
	  };
	
	  IndexPage.prototype.books = function books(allBook) {
	    var _this2 = this;
	
	    return allBook.edges.filter(function (node) {
	      return node.node.title.match(new RegExp('' + _this2.state.searchQuery));
	    });
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _this3 = this;
	
	    var inputClasses = (0, _classnames2.default)('search-input', {
	      hidden: !this.state.searchOpen
	    });
	
	    var allBook = this.props.data.allBook;
	
	
	    var books = allBook.edges.filter(function (book) {
	      var regex = new RegExp('.*' + _this3.state.searchQuery + '.*', 'i');
	      return book.node.title.match(regex);
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'info-bar' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'book-count' },
	          books.length,
	          ' Books'
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'search-form' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'search-button', onClick: this.toggleSearch },
	            '\uD83D\uDD0D'
	          ),
	          _react2.default.createElement('input', {
	            type: 'search',
	            value: this.state.searchQuery,
	            className: inputClasses,
	            placeholder: 'Book title...',
	            onChange: this.search
	          })
	        )
	      ),
	      books.map(function (_ref) {
	        var node = _ref.node;
	        return _react2.default.createElement(
	          'div',
	          { key: node.id, className: 'book' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'book-link', to: node.path },
	            _react2.default.createElement(
	              'h3',
	              null,
	              node.title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'book-info' },
	            _react2.default.createElement(
	              'span',
	              { className: 'info' },
	              node.author
	            ),
	            node.pageCount && _react2.default.createElement(
	              'span',
	              { className: 'info' },
	              node.pageCount,
	              ' pages'
	            )
	          )
	        );
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1aa71a13840e43556c36.js